import { formatNorwegianDay } from '@/lib/analytics/range'
import styles from './DateRangeControl.module.css'

export type DateRangeControlProps = {
  /** Inclusive ISO bounds (YYYY-MM-DD). */
  from: string
  to: string
  onChange: (next: { from: string; to: string }) => void
}

/** Shared from/to date-range picker for the Statistikk page. Native date
 * inputs (real calendar) — `lang="nb"` nudges Chromium/Edge to render them
 * day-first — plus an always-day-first DD.MM.YYYY readout, since the native
 * field's own text follows the browser locale and can't be forced from HTML. */
export default function DateRangeControl({ from, to, onChange }: DateRangeControlProps) {
  return (
    <div className={styles.root}>
      <label className={styles.field}>
        <span className={styles.label}>Fra</span>
        <input
          type="date"
          lang="nb"
          className={styles.input}
          value={from}
          max={to}
          onChange={(event) => {
            const next = event.currentTarget.value
            if (next !== '') onChange({ from: next, to })
          }}
        />
      </label>
      <label className={styles.field}>
        <span className={styles.label}>Til</span>
        <input
          type="date"
          lang="nb"
          className={styles.input}
          value={to}
          min={from}
          onChange={(event) => {
            const next = event.currentTarget.value
            if (next !== '') onChange({ from, to: next })
          }}
        />
      </label>
      <span className={styles.readout}>
        {formatNorwegianDay(from)} – {formatNorwegianDay(to)}
      </span>
    </div>
  )
}
